import { SNoop } from '@obvious.tech/util/validation/schemas'
import { defineEntity } from '../../defineEntity'
import { IMissionTemplate } from '@obvious.tech/constellation'

export const MissionTemplate = defineEntity('MissionTemplate', {
  endpoint: 'missions/api/MissionTemplate',
  schema: SNoop<IMissionTemplate>(),
})
